<template>
  <div>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="white"
    :transparent="true"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
      <div class="navbar-toggle d-inline" :class="{ toggled: $sidebar.showSidebar }">
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
    <!--  <a class="navbar-brand" href="#pablo"><img style="width: 2rem; margin-right: 1rem;" src="https://www.xabcdtrading.com/wp-content/uploads/logo-header.png"></a> -->
    </div>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">

      <div id="view-selector">
        <base-input>
          <select class="form-control" @change="onSelectView">
            <option class="optionfix" value="5050">50/50 View</option>
            <option class="optionfix" value="7030">70/30 View</option>
            <option class="optionfix" value="3070">30/70 View</option>
          </select>
        </base-input>
      </div>

      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template
          slot="title"
        >
          <img v-if="user.profileImg" style="border-radius: 100px; width: 1.75rem; height: 1.75rem;" :src="user.profileImg">
          <i v-if="!user.profileImg" class="tim-icons icon-single-02"></i>


          <b class="caret d-none d-lg-block d-xl-block"></b>
          <p class="d-lg-none">Log out</p>
        </template>

        <li class="nav-link">
          <a @click="profileModal = true" class="nav-item dropdown-item">Profile</a>
        </li>
        <li class="nav-link">
          <a @click="alertsModal = true" class="nav-item dropdown-item">Email Notifications</a>
        </li>
        <li class="nav-link">
          <a href="/my-account/api-downloads/" class="nav-item dropdown-item">Download Indicators</a>
        </li>
        <li class="nav-link">
          <a href="/my-account/api-keys/" class="nav-item dropdown-item">License Keys</a>
        </li>
        <div class="dropdown-divider"></div>
        <li class="nav-link">
          <a href="/dashboard/login.php?logout=true" class="nav-item dropdown-item">Log out</a>
        </li>
      </base-dropdown>
    </ul>
  </base-nav>

  <modal :show.sync="profileModal" body-classes="p-0" modal-classes="modal-sm">
    <card style="margin:0; padding:0;" class="card-user">
      <p class="card-text"></p>
      <div class="author">
        <div class="block block-one"></div>
        <div class="block block-two"></div>
        <div class="block block-three"></div>
        <div class="block block-four"></div>
        <a href="javascript:void(0)">
          <img v-if="user.profileImg" class="avatar" @click="attachFile()" :src="user.profileImg" alt="..." />
          <i v-if="!user.profileImg" class="avatar default tim-icons icon-single-02" @click="attachFile()"></i>
          <h5 class="title">{{user.user_nicename}}</h5>
        </a>

      </div>
      <p></p>
      <div class="card-description">

      </div>

      <div slot="footer" class="button-container">
          <input @change="uploadFile" style="display: none;" ref="filebtn" id="fileUpload" class="form-control-file" type="file">
      </div>
    </card>
  </modal>

  <modal :show.sync="alertsModal" body-classes="p-0" modal-classes="modal-md">
     <card type="secondary" header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0 mb-0">
        <h3>Email Notifications</h3>

        <form>

          <p>
          <label>Alert Notification</label>
          <base-switch class="base nudge" v-model="emailAlerts.alert" on-text="On" off-text="Off"></base-switch>
          </p>

          <p>
          <label>Send me alert emails even if i'm logged in</label>
          <base-switch class="base nudge" v-model="emailAlerts.evenIf" on-text="On" off-text="Off"></base-switch>
          </p>

          <p>
          <label>Maximum Alerts per Day:</label>
          <input class="form-control form-control-lg p-2" type="text" placeholder="Alerts per Day:" v-model="emailAlerts.perDay">
          </p>

          <p>
          <label>Chat Notification</label>
          <base-switch class="base nudge" v-model="emailAlerts.chat" on-text="On" off-text="Off"></base-switch>
          </p>

          <p>
          <label>Private Chat Notification</label>
          <base-switch class="base nudge" v-model="emailAlerts.private" on-text="On" off-text="Off"></base-switch>
          </p>

          <p>
            <label>User Mentioned Notification</label>
            <base-switch class="base nudge" v-model="emailAlerts.mention" on-text="On" off-text="Off"></base-switch>
          </p>

       </form>


     </card>
  </modal>

</div>
</template>
<script>
import {BaseSwitch} from '@/components';
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import SidebarToggleButton from './SidebarToggleButton';
const axios = require('axios');
import swal from 'sweetalert2';

export default {
  components: {
    BaseSwitch,
    axios,
    SidebarToggleButton,
    CollapseTransition,
    BaseNav,
    Modal
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    profileImg(){
      if(this.user.profileImg) return this.user.profileImg;
      return 'placeholder.img';
    }
  },
  data() {
    return {
      alertsModal: false,
      profileModal: false,
      emailAlerts: {alert: false, chat: false, private: false, mention: false, evenIf: false, perDay: 50},
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      user: window.user.data

    };
  },
  watch: {
    // whenever question changes, this function will run
    emailAlerts:{
      deep: true,
      async handler (newEmailAlerts, oldEmailAlerts) {
        this.$store.commit('updateEmailAlerts', newEmailAlerts);
        const response = await axios.get(process.env.VUE_APP_URL+'/dashboard/emailAlerts.php',{ params: {emailAlerts: newEmailAlerts, id:  window.user.data.ID} });
        console.log(response.data);
      }
    },
  },
  async mounted(){
      if(  window.user.data.emailAlerts) this.emailAlerts = window.user.data.emailAlerts;

      this.setView(localStorage.getItem('split-view') || '5050')
      document.querySelector('#view-selector select').value = localStorage.getItem('split-view') || '5050'
  },
  methods: {
    attachFile(){
      console.log('Upload Clicked!');
      const elem = this.$refs.filebtn;
      elem.click();

    },
    async uploadFile(event){
      console.log('Uploading!');
      this.files = event.target.files;
      const formData = new FormData();
      for (const i of Object.keys(this.files)) {
        formData.append('files', this.files[i]);
      }
      const response = await axios.post(process.env.VUE_APP_URL+':8443/file-upload', formData);
      console.log('Upload Complete!');
      if(response.data.success){
        var payload = { params: {profileImg: process.env.VUE_APP_URL+'/dashboard/uploads/'+response.data.name, id:  this.user.ID} };
        console.log(payload);
        const res = await axios.get(process.env.VUE_APP_URL+'/dashboard/updateAvatar.php',payload);
        console.log(res);
        this.user.profileImg = process.env.VUE_APP_URL+'/dashboard/uploads/'+response.data.name;
      }else{
        swal.fire({
         title: 'Sorry, image must be JPEG or PNG.',
         buttonsStyling: false,
         customClass: {
           confirmButton: 'btn btn-success btn-fill'
         }
       });
      }

    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    setView(view) {
      const stream = document.querySelector('#live-stream')
      const chat = document.querySelector('#live-chat')

      function removeColClasses(el) {
        const classes = el.className.split(" ").filter(c => !c.startsWith('col-'));
        el.className = classes.join(" ").trim();
      }

      localStorage.setItem('split-view', view);

      removeColClasses(stream)
      removeColClasses(chat)

      if (view === '5050') {
        stream.classList.add('col-lg-6')
        chat.classList.add('col-lg-6')
      }

      if (view === '3070') {
        stream.classList.add('col-lg-4')
        chat.classList.add('col-lg-8')
      }

      if (view === '7030') {
        stream.classList.add('col-lg-8')
        chat.classList.add('col-lg-4')
      }
    },
    onSelectView(event) {
      this.setView(event.target.value)
    }
  }
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}


@media (max-width: 991px) {
  #view-selector {
    display: none;
  }



}
</style>
